import SelectableCardGroup from './common/SelectableCardGroup';

const CHOICES = [
  { key: 'expert', title: '전문가 추천 위주로 보고 싶어요', desc: '웨딩 플래너나 실제 이용자의 추천을 믿고 따라가고 싶어요', icon: 'ri-vip-crown-line' },
  { key: 'compare', title: '여러 샵 비교 후 직접 결정하고 싶어요', desc: '직접 방문하고 비교한 후 내 취향에 맞는 곳을 찾고 싶어요', icon: 'ri-search-line' },
  { key: 'mixed', title: '둘 다 적절히 섞고 싶어요', desc: '추천은 참고하되, 직접 비교도 병행하고 싶어요', icon: 'ri-stack-line' },
];

interface StepShopStyleProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepShopStyle({ value, onChange }: StepShopStyleProps) {
  return <SelectableCardGroup options={CHOICES} value={value} onChange={onChange} />;
}
